import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routes.js";
import store from "../store/index.js";

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated =
    store.state.isAuthenticated === true ||
    localStorage.getItem("Auth") === "Y";

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "Login" });
    return;
  }

  if (to.name === "Login" && isAuthenticated) {
    next({ name: "Attendance" });
    return;
  }

  next();
});

export default router;
